// /**
//  * driver - Add
//  */

// React
import React, {useEffect, useState} from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import theme from '../../../theme';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {Button, Grid, Paper, Tab, Tabs, TextField, Typography} from '@material-ui/core';
import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiChevronDoubleDown,
  mdiChevronDoubleUp,
  mdiCommentQuestion,
  mdiCreditCard,
  mdiCurrencyUsd,
  mdiText,
} from '@mdi/js';

// Type
import {SelectorProps} from './interfaces';

// helpers'
import {flattenObject, removeEmptyValueObject} from '../../../utils/helpers';
import {addWalletDriversTransactionAction, getDriversWalletAction} from '../../drivers/actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../../redux/reducers';
import {makeSelectDriversWalletList, makeSelectError, makeSelectLoading} from '../../drivers/selectors';

import {useHistory} from 'react-router-dom';
import {Payload} from '../../drivers/interfaces';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Props = {
  match: {
    params: {
      id: number;
    };
  };
  driversWalletList: [];
  walletTransactionDispatch: (payload: Payload) => void;
  driversDispatch: (payload: Payload) => void;
};

type Inputs = {
  description: string;
  reason: string;
  amount: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& .MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    '.margin-date-0': {
      '&.MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    type: {
      flexGrow: 1,
      maxWidth: 500,
    },
    paper: {
      marginTop: '36px',
      width: '100%',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

function Index(props: Props) {
  const classes = useStyles();
  const {register, handleSubmit, errors, watch, setValue, getValues} = useForm<
    Inputs
  >({
    defaultValues: {
      employmentStartDate: null,
      birthDate: null,
    },
  });
  const [type, setType] = useState('INCREASE');
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);

  const history = useHistory();

  const checkEmptyInputs = (): boolean => {
    return (
      Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
        .length === 0
    );
  };

  const getDrivers = () => {
    const id = props?.match?.params?.id;
    let fleetId = {};
    if (id) {
      fleetId = {driverId: {equals: id}};
    }
    const {page, size} = filtersValues;
    props.driversDispatch({
      ...filtersValues,
      ...removeEmptyValueObject(fleetId),
      page,
      size,
    });
  };

  const onSubmit = (data: Inputs) => {
    const {
      description,
      reason,
      amount,
    } = data;

    const inputData = {
      description,
      reason,
      amount,
      type,
    };
    handleCreateParcel(inputData);
  };

  const handleCreateParcel = (transactionDate: any) => {
    const id = props?.match?.params?.id;
    props.walletTransactionDispatch({
      id: id,
      body: transactionDate,
      callback: () => history.push(`/drivers-wallet`),
    });
  };

  const handleChange = (event: any, newValue: any) => {
    setType(newValue);
  };

  useEffect(() => {
    getDrivers();
  }, [filtersValues]);

  const values = getValues();

  return (
    <>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        موجودی کیف پول 
        "${props.driversWalletList[0]?.driverName}"
        `}
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
      </Grid>
      <Grid container>
        <Paper
          style={{width: '30%'}}
          elevation={3}
          className={classes.paper}
          variant="elevation"
          square
        >
          <div className={classes.item}>
            <span style={{paddingLeft: '50px'}}>{'موجودی راننده (ریال):'}</span>
            <Grid item xs={6}>
              <span>{new Intl.NumberFormat('fa-IR').format(props.driversWalletList[0]?.amount)}</span>
            </Grid>
          </div>
        </Paper>
      </Grid>
      <form style={{display: 'flex'}} onSubmit={handleSubmit(onSubmit)}>
        <Grid container style={{margin: 0}} spacing={5} alignItems="flex-start">
          <Paper
            elevation={3}
            className={classes.paper}
            variant="elevation"
            square
          >
            <div style={{marginTop: '-66px'}} className={classes.addIcon}>
              <Icon
                path={mdiCreditCard}
                size={4}
                color={theme.palette.green.main}
              />
            </div>
            <Grid
              style={{padding: '30px 20px'}}
              container
              spacing={5}
              alignItems="flex-start"
            >
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCurrencyUsd}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="amount"
                      name="amount"
                      label="مبلغ (ریال)"
                      className={classes.textInput}
                      inputRef={register({required: true})}
                      error={errors.amount && true}
                    />
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCommentQuestion}
                      size={1}
                      className={classes.icon}
                      style={{transform: 'scale(-1, 1)'}}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="reason"
                      name="reason"
                      label={
                        'علت ' +
                        (type === 'INCREASE' ? 'افزایش' : 'کاهش')
                      }
                      className={classes.textInput}
                      inputRef={register({required: true})}
                      error={errors.reason && true}
                    />
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              ></Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <Paper square className={classes.type}>
                  <Tabs
                    value={type}
                    onChange={handleChange}
                    variant="fullWidth"
                    indicatorColor="secondary"
                    textColor="secondary"
                    aria-label="icon label tabs example"
                  >
                    <Tab
                      icon={<Icon path={mdiChevronDoubleDown} size={1} />}
                      label="کاهش"
                      value="DECREASE"
                    />
                    <Tab
                      icon={<Icon path={mdiChevronDoubleUp} size={1} />}
                      label="افزایش"
                      value="INCREASE"
                    />
                  </Tabs>
                </Paper>
              </Grid>
              <Grid container item xs={12} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiText} size={1} className={classes.icon} />
                  </span>

                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="description"
                      name="description"
                      label="توضیحات"
                      className={classes.textInput}
                      inputRef={register({required: true})}
                      error={errors.description && true}
                    />
                  </span>
                </div>
              </Grid>
            </Grid>
          </Paper>
          <Grid item container xs={12} justify="flex-end">
            <Grid item>
              <Button
                type="submit"
                fullWidth
                size="large"
                data-cy="search"
                autoFocus
                variant="contained"
                color="secondary"
                disabled={checkEmptyInputs()}
              >
                {'شارژ کیف پول'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  driversWalletList: makeSelectDriversWalletList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    driversDispatch: (payload: Payload) =>
      dispatch(getDriversWalletAction(payload)),
    walletTransactionDispatch: (payload: Payload) =>
      dispatch(addWalletDriversTransactionAction(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Index);
